import { TextField } from "@mui/material";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { MapContext } from "src/contexts/map";

const SearchBar = () => {
    const { t } = useTranslation();
    // when searching, the filters will be upated and the elements are then retrieved from the mapView component
    const { filters, updateFilters, updateNewElement } = useContext(MapContext);

    return (
        <TextField
            placeholder={t("search")}
            size="small"
            onChange={(e) => {
                updateNewElement(null);
                updateFilters({
                    ...filters,
                    search: e.target.value,
                });
            }}
            variant="outlined"
        />
    );
};

export default SearchBar;
